import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FactoryChild } from '../../factory.model';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { AuthService } from 'src/app/auth/auth.service';
import { UtilsService } from 'src/app/shared/utils.service';
import { ChangeImageComponent } from 'src/app/shared/change-image/change-image.component';

@Component({
    selector: 'app-add-edit-user',
    templateUrl: './add-edit-user.component.html',
    styleUrls: ['./add-edit-user.component.scss'],
    standalone: false
})
export class AddEditUserComponent implements OnInit {
  addUserForm: FormGroup;
  type: string;
  id: number;
  user: FactoryChild;
  userID: number;
  hide: boolean;
  meterMessage: string;
  passwordStrength: number;
  newImage: any;
  isDistributor = false;

  constructor(public dialogRef: MatDialogRef<AddEditUserComponent>,
              private dataService: DataService,
              private utils: UtilsService,
              private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any,
              private authService: AuthService) {
                if (this.authService.getUserData().type === this.utils.userTypes.Distributor) {
                  this.isDistributor = true;
                }
                this.type = data.type;
                this.id = data.id;
                this.user = data.user;
                this.userID = this.authService.getUserData().id;
                this.hide = true;
                this.meterMessage = '';
                this.passwordStrength = 0;
               }

  ngOnInit(): void {
    this.addUserForm = new FormGroup({
      firstName: new FormControl(this.user ? this.user.firstName : null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      lastName: new FormControl(this.user ? this.user.lastName : null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      email: new FormControl(this.user ? this.user.email : null,
        [Validators.required, Validators.email, this.utils.isValidEmail.bind(this)]),
      password_add: new FormControl(null, [Validators.required, Validators.pattern(/^(?=.*[a-zA-Z])(?=.*[0-9]).{8,}/)]),
      password_edit: new FormControl(null, [])
    });

    const passwordControl = this.addUserForm.controls.password_edit;

    passwordControl.valueChanges.subscribe(() => {
      if (this.type === 'Edit') {
        if (passwordControl.value === "" || passwordControl.value === null) {
          passwordControl.setValidators(null);
        } else {
          this.addUserForm.get('password_edit').setValidators([Validators.pattern(/^(?=.*[a-zA-Z])(?=.*[0-9]).{8,}/)]);
        }
        passwordControl.updateValueAndValidity({emitEvent: false});
      }
    });
  }

  editImage() {
    this.dialog.open(ChangeImageComponent, {
      disableClose: true,
      width: '500px',
      data: {dialogParent: this, existingImage: this.user && this.newImage ? this.newImage : this.user.picturePath, title: this.user.picturePath ? null : 'Add New Image', resizeImage: true, aspectRatio: true}
    }).afterClosed().subscribe(result => {
      if (result) {
        this.newImage = result.croppedImage64;
      }
    });
  }

  onStrengthChanged(strength: number) {
    if (strength === 60) {
      this.meterMessage = 'Weak password';
    } else if (strength === 80) {
      this.meterMessage = 'Normal password';
    } else if (strength === 100) {
      this.meterMessage = 'Strong password';
    } else {
      this.meterMessage = '';
    }
    this.passwordStrength = strength;
  }

  closeDialog() {
    if (this.addUserForm.dirty && this.type === 'Add') {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Warning',
          type: 'Warn',
          message: 'You will miss your information once you close',
          buttonText: 'cancel',
          numberOfButtons: 2,
          seconButtonText: 'Ok'
        }
      });
      dialogRef.afterClosed().subscribe((status) => {
        if (status === 'Ok') {
          this.dialog.closeAll();
        }
      });
    } else {
      this.dialog.closeAll();
    }
  }

  onSubmit() {
    if (this.type === 'Edit') {
      this.addUserForm.get('password_add').setValue('password123');
    } else {
      this.addUserForm.get('password_edit').setValue('password123');
    }
    if (this.addUserForm.valid) {
      if (this.type === 'Edit') {
        const payload = {
          id: parseInt(this.id.toString(), 10),
          firstName: this.addUserForm.get('firstName').value,
          lastName: this.addUserForm.get('lastName').value,
          email: this.addUserForm.get('email').value,
          password: this.addUserForm.get('password_edit').value,
        };

        if (this.newImage) {
          payload['image'] = this.newImage.slice(22, this.newImage.length);
        }

        let accountType = 'manufacturer/EditManufacturerChild/';
        if (this.isDistributor) {
          accountType = 'distributor/EditDistributorChild/';
        }
    
        this.dataService.put(accountType, payload).then((data) => {
          if (data.statusCode === 200) {
            if (this.newImage !== null && this.newImage !==  undefined) {
              payload['picturePath'] = this.newImage;
              this.dialogRef.close(payload);
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Success',
                  type: 'Success',
                  message: 'User information updated successfully',
                  buttonText: 'Ok'
                }
              });
            } else {
              this.dialogRef.close(payload);
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Success',
                  type: 'Success',
                  message: 'User information updated successfully',
                  buttonText: 'Ok'
                }
              });
            }
          } else if (data.statusCode === 600) {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                closeDialogRef: true,
                message: 'This email is already used. Please enter a new email!',
                buttonText: 'Ok'
              }
            });
          } else {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'Something went wrong, Please try again!',
                buttonText: 'Ok'
              }
            });
          }
        });
      } else if (this.type === 'Add') {
        const payload = {
          firstName: this.addUserForm.get('firstName').value,
          lastName: this.addUserForm.get('lastName').value,
          password: this.addUserForm.get('password_add').value,
          email: this.addUserForm.get('email').value,
          userId: parseInt(this.userID.toString(), 10)
        };
        let accountType = 'manufacturer/CreateManufacturerChild/';
        if (this.isDistributor) {
          accountType = 'distributor/CreateDistributorChild/';
        }
        this.dataService.post(accountType, payload).then((data) => {
          if (data.statusCode === 200) {
            payload['id'] = data.data.id;
            this.dialogRef.close(payload);
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Success',
                type: 'Success',
                message: 'User added successfully',
                buttonText: 'Ok'
              }
            });
          } else if (data.statusCode === 600) {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                closeDialogRef: true,
                message: 'This email is already used. Please enter a new email!',
                buttonText: 'Ok'
              }
            });
          } else {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'Something went wrong, Please try again!',
                buttonText: 'Ok'
              }
            });
          }
        });
      }
    } else {
      this.addUserForm.markAllAsTouched();
    }
  }

}
